export const AuthGrantTypes = Object.freeze({
    Password: 'password',
    AuthorizationCode: 'authorization_code',
    RefreshToken: 'refresh_token',
    LoginAsUser: 'login_as_user',
    LoginBackAsAdmin: 'login_back_as_admin'
});

export const AUTH_CODE_RESPONSE_TYPE = 'code';
export const AUTH_FORM_URL_ENCODED_CONTENT_TYPE = 'application/x-www-form-urlencoded';

export const AuthSessionEventTypes = Object.freeze({
    SignedIn: 'signed-in',
    SignedOut: 'signed-out',
    TokensUpdated: 'tokens-updated'
});

export type AuthSessionEventType = (typeof AuthSessionEventTypes)[keyof typeof AuthSessionEventTypes];
